import {
	SET_SETTINGS_TRANSACTIONS,
	SETTINGS_TRANSACTIONS,
	TOAST_MESSAGES_PUSH
} from '@/sections/transactions/shared/apisettings-mutation-types.js';

import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

const baseApi = `settings/transactions`;
let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'settingstransactions',
	namespaced: true,
	state: {
		[SETTINGS_TRANSACTIONS]: {}
	},
	mutations: {
		[SET_SETTINGS_TRANSACTIONS](state, data) {
			state[SETTINGS_TRANSACTIONS] = data;
		}
	},
	actions: {
		async [SET_SETTINGS_TRANSACTIONS]({ dispatch, commit }) {
			commit(SET_SETTINGS_TRANSACTIONS, {});
			let hasResultValue = false;
			await api
				.get(buildRoute(`options/${baseApi}`))
				.then(res => {
					commit(SET_SETTINGS_TRANSACTIONS, res);
					hasResultValue = true;
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
			return hasResultValue;
		}
	},
	getters: {
		[SETTINGS_TRANSACTIONS]: state => state[SETTINGS_TRANSACTIONS]
	}
};
